export default "__VITE_ASSET__b6d01adb__"